import React, { Suspense } from "react";
import {
  Route,
  Switch,
  withRouter,
} from "react-router-dom";
import classnames from "classnames";

// styles
import useStyles from "./styles";

// components
import Header from "../Header/Header";
import Sidebar from "../Sidebar/Sidebar";

// context
import { useLayoutState } from "../../context/LayoutContext";
import { CircularProgress } from "@material-ui/core";

const Dashboard = React.lazy(() => import('../../pages/dashboard/Dashboard'));
const DashboardDetail = React.lazy(() => import('../../pages/dashboard/Detail'));
const PushNotification = React.lazy(() => import('../../pages/PushNoti'));
const NotificationRequests = React.lazy(() => import('../../pages/NotiRequests'));
const WebHooks = React.lazy(() => import('../../pages/WebHooks'));
const Report = React.lazy(() => import('../../pages/PushNoti/report'));

function Layout(props) {
  var classes = useStyles();

  // global
  var layoutState = useLayoutState();

  return (
    <div className={classes.root}>
        <Suspense fallback={<div style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100vw", height: "100vh"}}><CircularProgress size={48} /></div>}>
          <Header history={props.history} />
          <Sidebar />
          <div
            className={classnames(classes.content, {
              [classes.contentShift]: layoutState.isSidebarOpened,
            })}
          >
            <div className={classes.fakeToolbar} />
            <Switch>
              <Route path="/app/dashboard" component={Dashboard} />
              <Route path="/app/detail/:type/:timeRange" component={DashboardDetail} />
              <Route path="/app/messages" component={PushNotification} />
              <Route path="/app/requests" component={NotificationRequests} />
              <Route path="/app/webhooks" component={WebHooks} />
              <Route path="/app/session-report/:nrId" component={Report} />
            </Switch>
          </div>
        </Suspense>
    </div>
  );
}

export default withRouter(Layout);
